<div
  class="attachments-edit-form"
  #attachmentsEditForm="ngbPopover"
  [ngbPopover]="attachmentsEditFormTpl"
  [popoverClass]="'attachments-edit-form__popover'"
  [placement]="'left'"
  [container]="'body'"
  [autoClose]="'outside'"
  (shown)="isOpened$.next(true)"
  (hidden)="isOpened$.next(false)"
>
  <ng-content></ng-content>
</div>

<ng-template #attachmentsEditFormHeaderTpl>
  <div class="attachments-edit-form__modal-header">
    <div class="attachments-edit-form__modal-header-label">{{ title }}</div>
    <div class="attachments-edit-form__modal-header-btn" (click)="attachmentsEditForm.close()">
      <i class="fa fa-times"></i>
    </div>
  </div>
</ng-template>

<ng-template #attachmentsEditFormTpl>
  <div class="attachments-edit-form__modal">
    <ng-container *ngIf="isOpened$ | async">
      <ng-container [ngTemplateOutlet]="attachmentsEditFormHeaderTpl"></ng-container>
      <div class="attachments-edit-form__modal-content">
        <app-attachments-form-type-selector
          (ready)="categorySelector = $event"
          (typeChange)="onEditFormChange({ label: $event })"
          [defaultValue]="updatedValues.label"
          [disabled]="isSaving$ | async"
        >
        </app-attachments-form-type-selector>
        <div class="form-indent"></div>
        <app-attachments-form-editor
          [model]="updatedValues"
          [disabled]="isSaving$ | async"
          (valueChange)="onEditFormChange($event)"
        ></app-attachments-form-editor>
      </div>
      <div class="attachments-edit-form__modal-footer">
        <div></div>
        <div class="attachments-edit-form__modal-footer-buttons">
          <button class="btn btn-default" (click)="attachmentsEditForm.close()">
            <span>CANCEL</span>
          </button>
          <button
            class="btn btn-primary"
            (click)="submitEditForm()"
            [disabled]="!(hasChanges$ | async) || (isSaving$ | async)"
          >
            <span>SAV{{ (isSaving$ | async) ? 'ING...' : 'E' }}</span>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
